module.exports = __webpack_public_path__ + "media/img/home/product_bg-ccc3cb276d390b9e10094cb35c0523b1.png";